import{Price}from'common/components/Price/Price';export default Price;